import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfter = ({ before, after, beforeLabel = "Avant", afterLabel = "Après", fit = "cover" }) => {
  const ref = useRef(null);
  const dragging = useRef(false);
  const [pos, setPos] = useState(50);
  const objectFit = fit === "contain" ? "object-contain" : "object-cover";

  const update = (clientX) => {
    const rect = ref.current.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };
  const onDown = (e) => {
    dragging.current = true;
    e.currentTarget.setPointerCapture(e.pointerId);
    update(e.clientX);
  };
  const onMove = (e) => {
    if (dragging.current) update(e.clientX);
  };
  const onUp = () => {
    dragging.current = false;
  };
  const onKey = (e) => {
    if (e.key === "ArrowLeft") setPos((p) => Math.max(0, p - 4));
    if (e.key === "ArrowRight") setPos((p) => Math.min(100, p + 4));
  };

  return (
    <div
      ref={ref}
      data-testid="before-after"
      onPointerDown={onDown}
      onPointerMove={onMove}
      onPointerUp={onUp}
      className="relative w-full h-[420px] sm:h-[560px] overflow-hidden select-none cursor-ew-resize border border-[#D4AF37]/20 bg-[#080f18]"
    >
      <img
        src={after}
        alt={afterLabel}
        draggable="false"
        className={`absolute inset-0 w-full h-full ${objectFit}`}
      />
      <img
        src={before}
        alt={beforeLabel}
        draggable="false"
        className={`absolute inset-0 w-full h-full ${objectFit}`}
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      />

      <span className="absolute top-4 left-4 bg-[#0A1420]/70 backdrop-blur-sm text-white text-xs uppercase tracking-widest px-3 py-1.5 pointer-events-none">
        {beforeLabel}
      </span>
      <span className="absolute top-4 right-4 bg-[#0A1420]/70 backdrop-blur-sm text-white text-xs uppercase tracking-widest px-3 py-1.5 pointer-events-none">
        {afterLabel}
      </span>

      <div
        className="absolute top-0 bottom-0 pointer-events-none"
        style={{ left: `${pos}%`, transform: "translateX(-50%)" }}
      >
        <div className="w-px h-full bg-[#D4AF37]" />
        <button
          type="button"
          aria-label="Comparer avant / après"
          aria-valuenow={Math.round(pos)}
          onKeyDown={onKey}
          className="pointer-events-auto absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-[#D4AF37] text-[#0A1420] flex items-center justify-center shadow-[0_0_22px_rgba(212,175,55,0.55)] focus:outline-none focus:ring-2 focus:ring-[#E6C27A]"
        >
          <MoveHorizontal size={22} />
        </button>
      </div>
    </div>
  );
};
